import React, {useState, useEffect, useRef} from 'react';
import {object, bool, func} from 'prop-types';
import {
    DatePickerCustom,
    InputCuenta,
    InputEntidad,
    InputLista,
    Loading,
    MessageModal,
    ProcessLoading,
    Accordion
} from '../../common';
import {CloneObject} from '../../../utils/helpers';
import {APIS} from '../../../config/apis';
import { ALERT_TYPE, APROBACION_STATE, PROCESO_STATE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import {ServerRequest} from '../../../utils/apiweb';
import {useConfiguracion} from '../../hooks/useConfiguracion';
import ProcesoModal from '../../controls/ProcesoModal';
import {EncodeTo64, getDateNow, getDateSerialize} from '../../../utils/convert';
import {useAccess} from '../../hooks/useAccess';
import {APPCONFIG} from '../../../app.config';
import {isEmptyString} from '../../../utils/validator';
import {ORDENAMIENTO_GENERAL} from '../../../consts/ordenamientoGeneral'
import { usePermissions } from '../../hooks';
import { PERMISSIONS } from '../../../consts/permissions';


const EmisionAprobacionesGrid = (props) => {

    const procesoInit = {
        id: 0,
        identificador: "",
        entidad: "",
        idEntidad: 0,
        idProcesoProgramacion: 0,
        idEstadoProceso: 0,
        idCategoriaProceso: 0,
        idTipoProceso: 0,
        fechaProceso: null,
        fechaInicio: null,
        fechaFin: null,
        descripcion: "",
        observacion: "",
        avance: 0,
        origen: "",
        idUsuarioCreacion: "",
        fechaCreacion: null,
        urlEjecucion: "",
        temporal: false,
        cancelacionSolicitada: false,
        cancelable: false,
        pausable: false
    }

    const aprobaciontInit = {
        id: 0,
        idEmisionEjecucion: 0,
        idEstadoProcesoInformeCalculo: 0,
        idUsuarioProcesoInformeCalculo: 0,
        fechaProcesoInformeCalculo: null,
        idEstadoProcesoControlRecibos: 0,
        idUsuarioProcesoControlRecibos: 0,
        fechaProcesoControlRecibos: null,
        idEstadoAprobacionCalculo: 0,
        idUsuarioAprobacionCalculo: 0,
        fechaAprobacionCalculo: null,
        idEstadoAprobacionControlRecibos: 0,
        idUsuarioAprobacionControlRecibos: 0,
        fechaAprobacionControlRecibos: null,
        idEstadoProcesoOrdenamiento: 0,
        idUsuarioProcesoOrdenamiento: null,
        fechaProcesoOrdenamiento: null,
        idEstadoProcesoInformeOrdenamiento: 0,
        idUsuarioProcesoInformeOrdenamiento: null,
        fechaProcesoInformeOrdenamiento: null,
        idEstadoAprobacionOrdenamiento: 0,
        idUsuarioAprobacionOrdenamiento: 0,
        fechaAprobacionOrdenamiento: null,
        idEstadoAprobacionCodigoBarras: 0,
        idUsuarioAprobacionCodigoBarras: 0,
        fechaAprobacionCodigoBarras: null,
        idEstadoProcesoCuentaCorriente: 0,
        idUsuarioProcesoCuentaCorriente: 0,
        fechaProcesoCuentaCorriente: null,
        idEstadoProcesoPublicacionDeuda: 0,
        idUsuarioProcesoPublicacionDeuda: 0,
        fechaProcesoPublicacionDeuda: null,
        idEstadoProcesoArchivoPublicacionDeuda: 0,
        idUsuarioProcesoArchivoPublicacionDeuda: null,
        fechaProcesoArchivoPublicacionDeuda: null,
        idEstadoProcesoImpresion: 0,
        idUsuarioProcesoImpresion: 0,
        fechaProcesoImpresion: null,
        idEstadoProcesoNotificacion: 0,
        idUsuarioProcesoNotificacion: 0,
        fechaProcesoNotificacion: null
    }

    const { hasPermission } = usePermissions();
    const canEditProceso = hasPermission(PERMISSIONS.PROCESO_EDIT);

    const processesPendingsRef = useRef(false);

    //hooks
    const [state, setState] = useState({
        emisionEjecucion: {
            id: 0,
            idEstadoEmisionEjecucion: 0,
            idEmisionDefinicion: 0,
            idOrdenamientoGeneral: 0,
            imprimeRecibosEmision: false
        },
        emisionDefinicion: {
            id: 0,
            idTipoTributo: 0,
            idBoletaDefinicion: 0
        },
        disabled: false,
        loading: false,
        showMessage: false,
        textMessage: ''
    });
    const [operacion, setOperacion] = useState({
        action: '',
        async: false,
        data: null
    });
    const [aprobacion, setAprobacion] = useState(aprobaciontInit);
    const [idOrdenamientoGeneralDefualt, setIdOrdenamientoGeneralDefualt] = useState(0);
    const [idOrdenamientoGeneral, setIdOrdenamientoGeneral] = useState(0);
    const [idCuentaControlRecibos, setIdCuentaControlRecibos] = useState(0);
    const [procesos, setProcesos] = useState({
        emisionAprobacionCalculo: procesoInit,
        aprobacionCalculo: procesoInit,
        emisionAprobacionControlRecibos: procesoInit,
        procesoOrdenamiento: procesoInit,
        emisionAprobacionOrdenamiento: procesoInit,
        aprobacionCodigoBarras: procesoInit
    });
    const [showProcesoModal, setShowProcesoModal] = useState(false);
    const [procesoEdit, setProcesoEdit] = useState(procesoInit);
    const [tiposProcesos, setTiposProcesos] = useState([]);


    const mount = () => {
        let myInterval = null;
        if (props.data) {
            setState(prevState => {
                return {
                    ...prevState,
                    emisionEjecucion: props.data.emisionEjecucion,
                    emisionDefinicion: props.data.emisionDefinicion
                };
            });
            setTiposProcesos(props.data.tiposProcesos);
            setIdOrdenamientoGeneral(props.data.emisionEjecucion.idOrdenamientoGeneral ?? 0);
            if (props.data.emisionEjecucion.id > 0 && props.data.tiposProcesos.length > 0) {
                FindEmisionAprobacion(props.data.emisionEjecucion.id);
                SearchProcesos(props.data.emisionEjecucion.id);
                myInterval = setInterval(() => {
                    if (processesPendingsRef.current) {
                        SearchProcesos(props.data.emisionEjecucion.id);
                    }
                }, APPCONFIG.GENERAL.PROCESS_TIME_INTERVAL * 1000);
            }
        }

        return () => {
            if (myInterval) clearInterval(myInterval)
        };
    }
    useEffect(mount, [props.data.emisionEjecucion, props.data.tiposProcesos]);

    const [ordenamientoGeneral, ,] = useConfiguracion({
        key: "OrdenamientoGeneral",
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });

    useEffect(() => {
        if (ordenamientoGeneral) {
            setIdOrdenamientoGeneralDefualt(parseInt(ordenamientoGeneral));
        } else {
            setIdOrdenamientoGeneralDefualt(0);
        }
    }, [ordenamientoGeneral]);

    const [accessEmisionAprobacionEdit, setAccessEmisionAprobacionEdit] = useState(false);
    const [access, readyAceess] = useAccess({
        key: '_SecurityAccesses',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });
    useEffect(() => {
        if (readyAceess) {
            const emision_aprobacion_edit = access.some(f => f.codigo === 'emision-aprobacion_edit');
            setAccessEmisionAprobacionEdit(emision_aprobacion_edit);
        }
    }, [readyAceess]);


    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackNoSuccess_NoShow = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                // ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessSearchProcesos = (response) => {
        response.json()
            .then((data) => {

                if (data.fechaCreacion) data.fechaCreacion = new Date(data.fechaCreacion);
                if (data.fechaProceso) data.fechaProceso = new Date(data.fechaProceso);
                if (data.fechaInicio) data.fechaInicio = new Date(data.fechaInicio);
                if (data.fechaFin) data.fechaFin = new Date(data.fechaFin);

                let procesosNew = {
                    emisionAprobacionCalculo: procesoInit,
                    aprobacionCalculo: procesoInit,
                    emisionAprobacionControlRecibos: procesoInit,
                    procesoOrdenamiento: procesoInit,
                    emisionAprobacionOrdenamiento: procesoInit,
                    aprobacionCodigoBarras: procesoInit
                }
                try {
                    //me quedo con el más reciente de cada grupo
                    const emisionAprobacionCalculo = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'EmisionAprobacionCalculo').id).sort((a,b) => b.id-a.id);
                    if (emisionAprobacionCalculo.length > 0) procesosNew.emisionAprobacionCalculo = emisionAprobacionCalculo[0];
                    const emisionAprobacionControlRecibos = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'EmisionAprobacionControlRecibos').id).sort((a,b) => b.id-a.id);
                    if (emisionAprobacionControlRecibos.length > 0) procesosNew.emisionAprobacionControlRecibos = emisionAprobacionControlRecibos[0];
                    const aprobacionCalculo = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'AprobacionCalculo').id).sort((a,b) => b.id-a.id);
                    if (aprobacionCalculo.length > 0) procesosNew.aprobacionCalculo = aprobacionCalculo[0];
                    const procesoOrdenamiento = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'ProcesoOrdenamiento').id).sort((a,b) => b.id-a.id);
                    if (procesoOrdenamiento.length > 0) procesosNew.procesoOrdenamiento = procesoOrdenamiento[0];
                    const emisionAprobacionOrdenamiento = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'EmisionAprobacionOrdenamiento').id).sort((a,b) => b.id-a.id);
                    if (emisionAprobacionOrdenamiento.length > 0) procesosNew.emisionAprobacionOrdenamiento = emisionAprobacionOrdenamiento[0];
                    const aprobacionCodigoBarras = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'AprobacionCodigoBarras').id).sort((a,b) => b.id-a.id);
                    if (aprobacionCodigoBarras.length > 0) procesosNew.aprobacionCodigoBarras = aprobacionCodigoBarras[0];
                }
                catch (error) {
                    const message = 'Error consultando procesos 1: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                }
                
                const processesPendings = data.filter(f => [PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(f.idEstadoProceso));
                processesPendingsRef.current = (processesPendings.length > 0);

                props.onProcessPendings(processesPendings.length);

                setProcesos(procesosNew);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessFindEmisionAprobacion = (response) => {
        response.json()
            .then((data) => {
                if (data.fechaProcesoInformeCalculo) data.fechaProcesoInformeCalculo = new Date(data.fechaProcesoInformeCalculo);
                if (data.fechaProcesoControlRecibos) data.fechaProcesoControlRecibos = new Date(data.fechaProcesoControlRecibos);
                if (data.fechaAprobacionCalculo) data.fechaAprobacionCalculo = new Date(data.fechaAprobacionCalculo);
                if (data.fechaAprobacionControlRecibos) data.fechaAprobacionControlRecibos = new Date(data.fechaAprobacionControlRecibos);
                if (data.fechaProcesoOrdenamiento) data.fechaProcesoOrdenamiento = new Date(data.fechaProcesoOrdenamiento);
                if (data.fechaProcesoInformeOrdenamiento) data.fechaProcesoInformeOrdenamiento = new Date(data.fechaProcesoInformeOrdenamiento);
                if (data.fechaAprobacionOrdenamiento) data.fechaAprobacionOrdenamiento = new Date(data.fechaAprobacionOrdenamiento);
                if (data.fechaAprobacionCodigoBarras) data.fechaAprobacionCodigoBarras = new Date(data.fechaAprobacionCodigoBarras);
                if (data.fechaProcesoCuentaCorriente) data.fechaProcesoCuentaCorriente = new Date(data.fechaProcesoCuentaCorriente);
                if (data.fechaProcesoArchivoPublicacionDeuda) data.fechaProcesoArchivoPublicacionDeuda = new Date(data.fechaProcesoArchivoPublicacionDeuda);
                if (data.fechaProcesoImpresion) data.fechaProcesoImpresion = new Date(data.fechaProcesoImpresion);
                if (data.fechaProcesoNotificacion) data.fechaProcesoNotificacion = new Date(data.fechaProcesoNotificacion);

                setAprobacion(data);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessModifyEmisionAprobacionAsync = (response) => {
        response.json()
            .then((data) => {
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Proceso iniciado...`);
                SearchProcesos(state.emisionEjecucion.id);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessModifyEmisionAprobacion = (response) => {
        if (props.onChange !== null) {
            props.onChange();
        }
        callbackSuccessFindEmisionAprobacion(response);
    }
    const callbackSuccesModifyCancelProceso = (response) => {
        response.json()
            .then((proceso) => {
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                if (proceso.cancelacionSolicitada)
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Proceso de cancelación iniciado`);
                else
                    ShowToastMessage(ALERT_TYPE.ALERT_WARNING, `Proceso cancelado correctamente`);
                SearchProcesos(state.emisionEjecucion.id);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }

    //funciones
    function SearchProcesos(idEmisionEjecucion) {

        const paramsUrl = `/emision-ejecucion/${idEmisionEjecucion}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PROCESO,
            paramsUrl,
            null,
            callbackSuccessSearchProcesos,
            callbackNoSuccess_NoShow,
            callbackError
        );

    }

    function FindEmisionAprobacion(idEmisionEjecucion) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/emision-ejecucion/${idEmisionEjecucion}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_APROBACION,
            paramsUrl,
            null,
            callbackSuccessFindEmisionAprobacion,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyEmisionAprobacion(idEmisionAprobacion, fechaProceso = null) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl =   (operacion.async) ?
                                (fechaProceso) ? `/async/${idEmisionAprobacion}/${operacion.action}/${getDateSerialize(fechaProceso)}` :
                                `/async/${idEmisionAprobacion}/${operacion.action}` :
                            `/${idEmisionAprobacion}/${operacion.action}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.EMISION_APROBACION,
            paramsUrl,
            operacion.data,
            (operacion.async) ? callbackSuccessModifyEmisionAprobacionAsync : callbackSuccessModifyEmisionAprobacion,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyCancelProceso(identificador) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/cancel/${identificador}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PROCESO,
            paramsUrl,
            null,
            callbackSuccesModifyCancelProceso,
            callbackNoSuccess,
            callbackError
        );

    }

    function EmisionAccion(fechaProceso = null) {
        ModifyEmisionAprobacion(aprobacion.id, fechaProceso);
        setState(prevState => {
            return {...prevState, showMessage: false, textMessage: ""};
        });
        setOperacion({action: "", async: false, data: null});
    }

    function NewProceso(descripcion) {
        let proceso = CloneObject(procesoInit);
        proceso.descripcion = descripcion;
        proceso.fechaProceso = getDateNow(true);
        setProcesoEdit(proceso);
        setShowProcesoModal(true);
    }

    //handles
    const handleInformeCalculo = () => {
        setState(prevState => {
            return {...prevState, showMessage: true, textMessage: "¿Está seguro/a de generar el informe de cálculo?"};
        });
        setOperacion({action: "EmisionAprobacionCalculo", async: true, data: null});
    }
    const handleAprobarCalculo = () => {
        setOperacion({action: "AprobacionCalculo", async: true, data: null});
        NewProceso("Aprobación de Cálculo");
    }
    const handleInformeControlRecibos = () => {
        if (idCuentaControlRecibos <= 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar una cuenta primero');
            return false;
        }
        setState(prevState => {
            return {...prevState, showMessage: true, textMessage: "¿Está seguro/a de generar la boleta?"};
        });
        setOperacion({
            action: "EmisionAprobacionControlRecibos",
            async: true,
            data: { idCuenta: idCuentaControlRecibos }
        });
    }
    const handleAprobarControlRecibos = () => {
        setState(prevState => {
            return {
                ...prevState,
                showMessage: true,
                textMessage: "¿Está seguro/a de aprobar el proceso de control de VEPs?"
            };
        });
        setOperacion({action: "AprobacionControlRecibos", async: false, data: null});
    }
    const handleProcesoOrdenamiento = () => {
        if (idOrdenamientoGeneral <= 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar el método de ordenamiento primero');
            return false;
        }
        setOperacion({
            action: "ProcesoOrdenamiento",
            async: true,
            data: { idOrdenamientoGeneral: idOrdenamientoGeneral }
        });
        NewProceso("Proceso de Ordenamiento");
    }
    const handleInformeOrdenamiento = () => {
        setState(prevState => {
            return {
                ...prevState,
                showMessage: true,
                textMessage: "¿Está seguro/a de generar el informe de ordenamiento?"
            };
        });
        setOperacion({action: "EmisionAprobacionOrdenamiento", async: true, data: null});
    }
    const handleAprobarOrdenamiento = () => {
        setState(prevState => {
            const htmlMessage = <span>El proceso de ordenamiento no podrá ser ejecutado nuevamente luego de la aprobación.<br/>¿Está seguro/a de aprobar el proceso de ordenamiento?</span>;
            return {...prevState, showMessage: true, textMessage: htmlMessage};
        });
        setOperacion({action: "AprobacionOrdenamiento", async: false, data: null});
    }
    const handleAprobarCodigoBarras = () => {
        setOperacion({action: "AprobacionCodigoBarras", async: true, data: null});
        NewProceso("Aprobación de Código de Barras");
    }

    return (
        <>

            <Loading visible={state.loading}></Loading>

            {state.showMessage &&
                <MessageModal
                    title={"Confirmación"}
                    message={state.textMessage}
                    onDismiss={() => {
                        setState(prevState => {
                            return {...prevState, showMessage: false, rowForm: null};
                        });
                    }}
                    onConfirm={() => {
                        setState(prevState => {
                            return {...prevState, showMessage: false};
                        });
                        EmisionAccion();
                    }}
                />
            }

            {showProcesoModal &&
                <ProcesoModal
                    proceso={procesoEdit}
                    onDismiss={() => {
                        setShowProcesoModal(false);
                    }}
                    onConfirm={(row) => {
                        setShowProcesoModal(false);
                        EmisionAccion(row.fechaProceso);
                    }}
                    onCancel={(row) => {
                        setShowProcesoModal(false);
                        ModifyCancelProceso(row.identificador);
                    }}
                    disabled={props.disabled || !canEditProceso}
                />
            }

            <div className='m-top-20'>
                <Accordion title="Cálculo" startOpen={true}>
                    {(state.emisionEjecucion.imprimeRecibosEmision && (state.emisionDefinicion.idBoletaDefinicion??0) > 0) &&
                    <div className='row align-items-end'>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idEstadoProcesoControlRecibos" className="form-label">Estado de control de boleta</label>
                            <InputLista
                                name="idEstadoProcesoControlRecibos"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idEstadoProcesoControlRecibos}
                                lista="EstadoProceso"
                                disabled={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idUsuarioProcesoControlRecibos" className="form-label">Usuario/a</label>
                            <InputEntidad
                                name="idUsuarioProcesoControlRecibos"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idUsuarioProcesoControlRecibos}
                                entidad="Usuario"
                                disabled={true}
                                onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaProcesoControlRecibos" className="form-label">Fecha</label>
                            <DatePickerCustom
                                name="fechaProcesoControlRecibos"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.fechaProcesoControlRecibos}
                                disabled={true}
                                time={true}
                            />
                        </div>
                        {!props.disabled &&
                        <div className="mb-3 col-12 col-md-6 col-lg-4 align-items-center">
                            <div className='row display-row align-items-center'>
                                <div className="col-6">
                                    <InputCuenta
                                        name="idCuenta"
                                        placeholder="Seleccione una cuenta..."
                                        className="form-control m-top-25"
                                        value={idCuentaControlRecibos}
                                        onChange={(event) => {
                                            const {target} = event;
                                            setIdCuentaControlRecibos(target.value);
                                        }}
                                        disabled={false}
                                        idTipoTributo={state.emisionDefinicion.idTipoTributo}
                                    />
                                </div>
                                {(idCuentaControlRecibos > 0) &&
                                <div className="col-6 m-top-20 display-row align-items-center">
                                    <button
                                        className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => handleInformeControlRecibos()}>
                                        Imprimir boleta
                                    </button>
                                    <ProcessLoading
                                        className="m-left-5"
                                        proceso={procesos.emisionAprobacionControlRecibos}
                                        onFinish={() => {
                                            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Informe generado exitosamente. Podrá descargar el archivo en la sección de "Información adicional"`);
                                            if (props.onChange !== null) {
                                                props.onChange();
                                            }
                                        }}
                                        onClick={(row) => {
                                            setProcesoEdit(row);
                                            setShowProcesoModal(true);
                                        }}
                                        showFinalizado={true}
                                    />
                                </div>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                    <div className='row align-items-end'>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idEstadoProcesoInformeCalculo" className="form-label">Estado de informe</label>
                            <InputLista
                                name="idEstadoProcesoInformeCalculo"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idEstadoProcesoInformeCalculo}
                                lista="EstadoProceso"
                                disabled={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idUsuarioProcesoInformeCalculo" className="form-label">Usuario/a</label>
                            <InputEntidad
                                name="idUsuarioProcesoInformeCalculo"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idUsuarioProcesoInformeCalculo}
                                entidad="Usuario"
                                disabled={true}
                                onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaProcesoInformeCalculo" className="form-label">Fecha</label>
                            <DatePickerCustom
                                name="fechaProcesoInformeCalculo"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.fechaProcesoInformeCalculo}
                                disabled={true}
                                time={true}
                            />
                        </div>
                        {!props.disabled &&
                        <div className="mb-3 col-12 col-md-6 col-lg-3 m-top-20 align-items-center display-row">
                            <button
                                disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.emisionAprobacionCalculo.idEstadoProceso)}
                                className="btn back-button" data-dismiss="modal"
                                onClick={(event) => handleInformeCalculo()}>
                                Informe de cálculo
                            </button>
                            <ProcessLoading
                                className="m-left-5"
                                proceso={procesos.emisionAprobacionCalculo}
                                onFinish={() => {
                                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Informe generado exitosamente. Podrá descargar el archivo en la sección de "Información adicional"`);
                                    if (props.onChange !== null) {
                                        props.onChange();
                                    }
                                }}
                                onClick={(row) => {
                                    setProcesoEdit(row);
                                    setShowProcesoModal(true);
                                }}
                                showFinalizado={true}
                            />
                        </div>
                        }
                    </div>
                    <div className='row align-items-end'>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idEstadoAprobacionCalculo" className="form-label">Estado de cálculo</label>
                            <InputLista
                                name="idEstadoAprobacionCalculo"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idEstadoAprobacionCalculo}
                                lista="EstadoAprobacion"
                                disabled={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idUsuarioAprobacionCalculo" className="form-label">Usuario/a</label>
                            <InputEntidad
                                name="idUsuarioAprobacionCalculo"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idUsuarioAprobacionCalculo}
                                entidad="Usuario"
                                disabled={true}
                                onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaAprobacionCalculo" className="form-label">Fecha</label>
                            <DatePickerCustom
                                name="fechaAprobacionCalculo"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.fechaAprobacionCalculo}
                                disabled={true}
                                time={true}
                            />
                        </div>
                        {(!props.disabled && accessEmisionAprobacionEdit && aprobacion.idEstadoAprobacionCalculo === APROBACION_STATE.PENDIENTE &&
                                                                            aprobacion.idEstadoProcesoInformeCalculo === PROCESO_STATE.FINALIZADO &&
                                                                            aprobacion.idEstadoProcesoControlRecibos === PROCESO_STATE.FINALIZADO) &&
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <div className='display-row align-items-center'>
                                <button
                                    disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.aprobacionCalculo.idEstadoProceso)}
                                    className="btn action-button" data-dismiss="modal"
                                    onClick={(event) => handleAprobarCalculo()}>
                                    Aprobar
                                </button>
                                <ProcessLoading
                                    className="m-left-5"
                                    proceso={procesos.aprobacionCalculo}
                                    onFinish={() => {
                                        FindEmisionAprobacion(state.emisionEjecucion.id);
                                        if (props.onChange !== null) {
                                            props.onChange();
                                        }
                                    }}
                                    onClick={(row) => {
                                        setProcesoEdit(row);
                                        setShowProcesoModal(true);
                                    }}
                                    showFinalizado={true}
                                />
                            </div>
                        </div>
                        }
                    </div>
                </Accordion>
            </div>

            {(state.emisionEjecucion.imprimeRecibosEmision && (state.emisionDefinicion.idBoletaDefinicion??0) > 0) &&
            <div className='m-top-20'>
                <Accordion title="Ordenamiento">
                    {aprobacion.idEstadoAprobacionControlRecibos === APROBACION_STATE.APROBADO &&
                    <>
                    <div className='row align-items-end'>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idEstadoProcesoOrdenamiento" className="form-label">Estado de proceso</label>
                            <InputLista
                                name="idEstadoProcesoOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idEstadoProcesoOrdenamiento}
                                lista="EstadoProceso"
                                disabled={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idUsuarioProcesoOrdenamiento" className="form-label">Usuario/a</label>
                            <InputEntidad
                                name="idUsuarioProcesoOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idUsuarioProcesoOrdenamiento}
                                entidad="Usuario"
                                disabled={true}
                                onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaProcesoOrdenamiento" className="form-label">Fecha</label>
                            <DatePickerCustom
                                name="fechaProcesoOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.fechaProcesoOrdenamiento}
                                disabled={true}
                                time={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-3">
                            <label htmlFor="idOrdenamientoGeneral" className="form-label">Método de ordenamiento</label>
                            <InputLista
                                name="idOrdenamientoGeneral"
                                placeholder=""
                                className="form-control"
                                value={idOrdenamientoGeneral}
                                onChange={({target}) => {
                                    let id = 0;
                                    if (target.row) id = target.row.id;
                                    setIdOrdenamientoGeneral(id);
                                }}
                                lista="OrdenamientoGeneral"
                                disabled={props.disabled || aprobacion.idEstadoAprobacionOrdenamiento !== APROBACION_STATE.PENDIENTE ||
                                                            [PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.procesoOrdenamiento.idEstadoProceso)
                                }
                            />
                        </div>
                        {!props.disabled && aprobacion.idEstadoAprobacionOrdenamiento === APROBACION_STATE.PENDIENTE &&
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <div className='display-row align-items-center'>
                                <button
                                    disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.procesoOrdenamiento.idEstadoProceso)}
                                    className="btn back-button" data-dismiss="modal"
                                    onClick={(event) => handleProcesoOrdenamiento()}>
                                    Procesar
                                </button>
                                <ProcessLoading
                                    className="m-left-5"
                                    proceso={procesos.procesoOrdenamiento}
                                    onFinish={() => {
                                        FindEmisionAprobacion(state.emisionEjecucion.id);
                                        if (props.onChange !== null) {
                                            props.onChange();
                                        }
                                    }}
                                    onClick={(row) => {
                                        setProcesoEdit(row);
                                        setShowProcesoModal(true);
                                    }}
                                    showFinalizado={true}
                                />
                            </div>
                        </div>
                        }
                    </div>
                    <div className='row align-items-end'>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idEstadoProcesoInformeOrdenamiento" className="form-label">Estado de informe</label>
                            <InputLista
                                name="idEstadoProcesoInformeOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idEstadoProcesoInformeOrdenamiento}
                                lista="EstadoProceso"
                                disabled={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idUsuarioProcesoInformeOrdenamiento" className="form-label">Usuario/a</label>
                            <InputEntidad
                                name="idUsuarioProcesoInformeOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idUsuarioProcesoInformeOrdenamiento}
                                entidad="Usuario"
                                disabled={true}
                                onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaProcesoInformeOrdenamiento" className="form-label">Fecha</label>
                            <DatePickerCustom
                                name="fechaProcesoInformeOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.fechaProcesoInformeOrdenamiento}
                                disabled={true}
                                time={true}
                            />
                        </div>
                        {!props.disabled && aprobacion.idEstadoProcesoOrdenamiento === PROCESO_STATE.FINALIZADO &&
                        <div className="mb-3 col-12 col-md-6 col-lg-3">
                            <div className='display-row align-items-center'>
                                <button
                                    disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.procesoOrdenamiento.idEstadoProceso)}
                                    className="btn back-button" data-dismiss="modal"
                                    onClick={(event) => handleInformeOrdenamiento()}>
                                    Informe de ordenamiento
                                </button>
                                <ProcessLoading
                                    className="m-left-5"
                                    proceso={procesos.emisionAprobacionOrdenamiento}
                                    onFinish={() => {
                                        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Informe generado exitosamente. Podrá descargar el archivo en la sección de "Información adicional"`);
                                        if (props.onChange !== null) {
                                            props.onChange();
                                        }
                                    }}
                                    onClick={(row) => {
                                        setProcesoEdit(row);
                                        setShowProcesoModal(true);
                                    }}
                                    showFinalizado={true}
                                />
                            </div>
                        </div>
                        }
                    </div>
                    </>}
                    <div className='row align-items-end'>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idEstadoAprobacionOrdenamiento" className="form-label">Estado de ordenamiento</label>
                            <InputLista
                                name="idEstadoAprobacionOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idEstadoAprobacionOrdenamiento}
                                lista="EstadoAprobacion"
                                disabled={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idUsuarioAprobacionOrdenamiento" className="form-label">Usuario/a</label>
                            <InputEntidad
                                name="idUsuarioAprobacionOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idUsuarioAprobacionOrdenamiento}
                                entidad="Usuario"
                                disabled={true}
                                onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaAprobacionOrdenamiento" className="form-label">Fecha</label>
                            <DatePickerCustom
                                name="fechaAprobacionOrdenamiento"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.fechaAprobacionOrdenamiento}
                                disabled={true}
                                time={true}
                            />
                        </div>
                        {!props.disabled && accessEmisionAprobacionEdit && aprobacion.idEstadoAprobacionOrdenamiento === APROBACION_STATE.PENDIENTE &&
                                                                           aprobacion.idEstadoAprobacionControlRecibos === APROBACION_STATE.APROBADO &&
                                                                           aprobacion.idEstadoProcesoOrdenamiento === PROCESO_STATE.FINALIZADO &&
                                                                           aprobacion.idEstadoProcesoInformeOrdenamiento === PROCESO_STATE.FINALIZADO &&
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <button
                                className="btn action-button m-top-25 no-m-horizontal" data-dismiss="modal"
                                onClick={(event) => handleAprobarOrdenamiento()}>
                                Aprobar
                            </button>
                        </div>
                        }
                    </div>
                </Accordion>
            </div>
            }

            {(state.emisionEjecucion.imprimeRecibosEmision) &&
            <div className="m-top-20">
                <Accordion title="Código de barras">
                    <div className='row align-items-end'>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idEstadoAprobacionCodigoBarras" className="form-label">Estado</label>
                            <InputLista
                                name="idEstadoAprobacionCodigoBarras"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idEstadoAprobacionCodigoBarras}
                                lista="EstadoAprobacion"
                                disabled={true}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="idUsuarioAprobacionCodigoBarras" className="form-label">Usuario/a</label>
                            <InputEntidad
                                name="idUsuarioAprobacionCodigoBarras"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.idUsuarioAprobacionCodigoBarras}
                                entidad="Usuario"
                                disabled={true}
                                onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                            />
                        </div>
                        <div className="mb-3 col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaAprobacionCodigoBarras" className="form-label">Fecha</label>
                            <DatePickerCustom
                                name="fechaAprobacionCodigoBarras"
                                placeholder=""
                                className="form-control"
                                value={aprobacion.fechaAprobacionCodigoBarras}
                                disabled={true}
                                time={true}
                            />
                        </div>
                        {(!props.disabled && accessEmisionAprobacionEdit && aprobacion.idEstadoAprobacionCodigoBarras === APROBACION_STATE.PENDIENTE &&
                                                                            aprobacion.idEstadoAprobacionOrdenamiento === APROBACION_STATE.APROBADO) &&
                        <div className="mb-3 col-12 col-md-6 col-lg-3 m-top-20 align-items-center display-row">
                            <button
                                disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.aprobacionCodigoBarras.idEstadoProceso)}
                                className="btn action-button" data-dismiss="modal"
                                onClick={(event) => handleAprobarCodigoBarras()}>
                                Aprobar
                            </button>
                            <ProcessLoading
                                className="m-left-5"
                                proceso={procesos.aprobacionCodigoBarras}
                                onFinish={() => {
                                    FindEmisionAprobacion(state.emisionEjecucion.id);
                                    if (props.onChange !== null) {
                                        props.onChange();
                                    }
                                }}
                                onClick={(row) => {
                                    setProcesoEdit(row);
                                    setShowProcesoModal(true);
                                }}
                                showFinalizado={true}
                            />
                        </div>
                        }
                    </div>
                </Accordion>
            </div>
            }
        </>
    );
}

EmisionAprobacionesGrid.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onChange: func,
    onProcessPendings: func
};

EmisionAprobacionesGrid.defaultProps = {
    disabled: false,
    onChange: null,
    onProcessPendings: null
};

export default EmisionAprobacionesGrid;